import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { LanguageProvider, useLanguage } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Profile from "./components/Profile";
import Services from "./components/Services";
import TechFocus from "./components/TechFocus";
import { Industries, Differentiators } from "./components/IndustriesAndWhy";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ServiceDetail from "./pages/ServiceDetail";
import { Toaster } from "./components/ui/toaster";
import SeoHead, { SEO_CONFIG } from "./seo/SeoHead"; // NEU

function HashScroll() {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 50);
    }
  }, [hash, pathname]);
  return null;
}

/** Startseite mit SEO-Head */
const Home = () => {
  const { lang } = useLanguage();
  const seo = SEO_CONFIG.home[lang] || SEO_CONFIG.home.de;
  return (
    <>
      <SeoHead {...seo} lang={lang} />
      <Hero />
      <Profile />
      <Services />
      <TechFocus />
      <Industries />
      <Differentiators />
      <Contact />
    </>
  );
};

function Shell() {
  return (
    <div className="min-h-screen bg-white text-slate-900 font-[Inter,ui-sans-serif,system-ui] antialiased selection:bg-teal-200/60">
      <Navbar />
      <HashScroll />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/leistungen/:slug" element={<ServiceDetail />} />
        </Routes>
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
